'use strict';

var LoadingBus = function LoadingBus() {
  var _this = this;

  this.events = {};

  this.$emit = function (eventName, opts) {
    _this.events[eventName].forEach(function (item) {
      return item(opts);
    });
  };

  this.$on = function (eventName, handler) {
    if (typeof handler !== 'function') {
      throw TypeError('[Loading]: event handler must be a function!');
    }
    if (!_this.events[eventName]) {
      _this.events[eventName] = [];
    }

    _this.events[eventName].push(handler);
  };
};

var LBus = new LoadingBus();

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = ".wrapper[data-v-efe9d588] { position: fixed; top: 0; right: 0; bottom: 0; left: 0; margin: auto; z-index: 999; border-radius: 5%; background-color: rgba(0, 0, 0, 0.6); } .wrapper .loading[data-v-efe9d588] { position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto; height: 50px; width: 50px; } ";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();

var Loading = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _vm.isShow ? _c('div', [_vm.type === 'wx' ? _c('div', { staticClass: "wrapper", style: { height: _vm.height + 'px', width: _vm.width + 'px', 'background-color': _vm.primary } }, [_c('svg', { staticClass: "loading" }, [_c('path', { attrs: { "fill": _vm.secondary, "d": "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z", "transform": "rotate(285.32 25 25)" } }, [_c('animateTransform', { attrs: { "attributeType": "xml", "attributeName": "transform", "type": "rotate", "from": "0 25 25", "to": "360 25 25", "dur": "0.6s", "repeatCount": "indefinite" } })], 1)])]) : _vm._e()]) : _vm._e();
  }, staticRenderFns: [], _scopeId: 'data-v-efe9d588',
  props: {
    height: {
      default: 100
    },
    width: {
      default: 100
    },
    type: {
      default: 'wx'
    },
    primary: {
      default: 'rgba(0,0,0,.6)'
    },
    secondary: {
      default: '#fff'
    }
  },

  data: function data() {
    return {
      isShow: false
    };
  },
  created: function created() {
    var _this = this;

    LBus.$on('show', function () {
      _this.isShow = true;
    });

    LBus.$on('hide', function () {
      _this.isShow = false;
    });
  }
};

var Loading$1 = {
  install: function install(v) {
    v.prototype.$loading = this;
    v.component('global-loading', Loading);
  },
  show: function show() {
    LBus.$emit('show');
  },
  hide: function hide() {
    LBus.$emit('hide');
  }
};

module.exports = Loading$1;
